import clsx from 'clsx';
import React, { useState } from 'react';
import { useWindowSize } from 'usehooks-ts';

import hamburgerIcon from 'images/hamburger_icon.svg';
import tiLogo from 'images/logo.png';
import searchIcon from 'images/search_icon.svg';
import whiteTiLogo from 'images/the-information-logo-for-dark.svg';

import { root_path, search_page_path, static_index_path } from '../../routes';
import { NavCurrentUser } from '../../utils/backend-api/currentUser';
import NavLinks from './NavLinks';
import SideNav from './SideNav';
import SubscriberActions from './SubscriberActions';
import styles from './styles.module.css';

export default function TopNav({
  colorScheme,
  currentUser,
  isFullNav,
  isWebview,
  newForumPostsCount,
  overrideOfferCode,
  shouldOpenReferralModal,
}: {
  colorScheme?: string;
  currentUser: NavCurrentUser;
  isFullNav: boolean;
  isWebview: boolean;
  overrideOfferCode?: string;
  newForumPostsCount: number;
  shouldOpenReferralModal: boolean;
}) {
  const [showSideNav, setShowSideNav] = useState<boolean>(false);
  const [dropdownShown, setDropdownShown] = useState<string>('');
  const { width } = useWindowSize();

  const closeNav = () => {
    setShowSideNav(false);
    setDropdownShown('');
  };

  return (
    <>
      <div className={styles.TopNav} data-test="top-nav">
        <div
          className={clsx(styles.topRowWrapper, {
            [styles.darkTheme]: colorScheme == 'dark' && width >= 768,
            [styles.lightTheme]: colorScheme == 'light',
          })}
        >
          <div className={styles.topRow}>
            <div className={styles.topRowIcons}>
              {width >= 1200 && isFullNav ? (
                <a className={styles.altNavLink} href={static_index_path()}>
                  About
                </a>
              ) : (
                <a
                  onClick={() => setShowSideNav((prevState) => !prevState)}
                  data-test="nav-hamburger-toggle"
                  className={styles.sideNavToggle}
                >
                  <img className={styles.navIcon} src={hamburgerIcon} height="32" width="30" />
                </a>
              )}
              <a
                className={clsx(styles.navIcon, styles.searchWrapper)}
                href={search_page_path()}
                data-test="top-nav-search-link"
              >
                <img src={searchIcon} width="24" height="24" title="Search" alt="Search" />
              </a>
            </div>
            <a href={root_path()} className={styles.logoWrapper}>
              <img
                src={colorScheme == 'dark' && width >= 768 ? whiteTiLogo : tiLogo}
                width="235.6"
                height="40"
              />
            </a>
            <SubscriberActions
              colorScheme={colorScheme}
              currentUser={currentUser}
              dropdownShown={dropdownShown}
              overrideOfferCode={overrideOfferCode}
              setDropdownShown={setDropdownShown}
              shouldOpenReferralModal={shouldOpenReferralModal}
              variant="top"
            />
          </div>
        </div>
        {isFullNav && (
          <div className={styles.secondRow} data-test="nav-second-row">
            <NavLinks
              dropdownShown={dropdownShown}
              isWebview={isWebview}
              setDropdownShown={setDropdownShown}
              variant="top"
              newForumPostsCount={newForumPostsCount}
            />
          </div>
        )}
      </div>
      <SideNav
        closeNav={closeNav}
        currentUser={currentUser}
        dropdownShown={dropdownShown}
        newForumPostsCount={newForumPostsCount}
        overrideOfferCode={overrideOfferCode}
        setDropdownShown={setDropdownShown}
        shouldOpenReferralModal={shouldOpenReferralModal}
        show={showSideNav}
      />
    </>
  );
}
